import Component from './ManageCompanies';

export default Component;
